import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTimeOfDay } from '../../hooks/useTimeOfDay';
import './Auth.css';
import Copyright from '../Layout/Copyright';

function LoginForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, error, clearError } = useAuth();
  const timeOfDay = useTimeOfDay();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;

    setLoading(true);
    await login(username, password);
    setLoading(false);
  };

  const backgroundImage = timeOfDay === 'morning'
    ? 'url(/loginmorn.png)'
    : 'url(/loginday.jpg)';

  useEffect(() => {
    const initLogo = () => {
      if (window.MSTLogo && document.getElementById('mst-logo-login')) {
        window.MSTLogo.init('mst-logo-login', { size: 50 });
      }
    };

    if (window.MSTLogo) {
      initLogo();
      return;
    }

    const existing = document.getElementById('mst-spinner-script');
    if (existing) {
      existing.addEventListener('load', initLogo);
      return;
    }

    const script = document.createElement('script');
    script.id = 'mst-spinner-script';
    script.src = '/mst-logo-spinner.js';
    script.onload = initLogo;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="auth-page" style={{ backgroundImage }}>
      <div className="auth-card">
        <div className="auth-header">
          <img src="/logo.png" alt="WFMZ" className="auth-logo" />
          <p className="auth-subtitle">Sign in to your account</p>
        </div>

        {error && (
          <div className="alert alert-error">
            {error}
            <button onClick={clearError} className="alert-close">&times;</button>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <input
              id="username"
              type="text"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              autoComplete="username"
              autoFocus
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              id="password"
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg auth-submit"
            disabled={loading || !username || !password}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="auth-footer">
          <Link to="/reset-password">Forgot your password?</Link>
        </div>
      </div>

      <div className="auth-developer">
        <div id="mst-logo-login" />
      </div>

      <Copyright showNotice className="copyright-on-image" />
    </div>
  );
}

export default LoginForm;
